var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agency-info",attrs:{"data-test-id":"AgencyInfoComponent"}},[(_vm.selectedEmsAgency)?_c('p',{attrs:{"data-test-id":"AgencyItem"}},[_vm._v(_vm._s(_vm.selectedEmsAgency.name)+" "+_vm._s(_vm.additionalText))]):_c('p',{attrs:{"data-test-id":"NoAgencyItem"}},[_vm._v("Please select an EMS Agency")])])
}
var staticRenderFns = []

export { render, staticRenderFns }